/**
 * SearchBar.jsx
 *
 * Arama kutusu, top-k slider ve arama butonu.
 * SOLID - Single Responsibility: Sadece kullanıcı girdisinden sorumludur.
 * Hiçbir API çağrısı içermez; onSearch callback'ini çağırır.
 */

import React, { useState } from "react";

function SearchBar({ onSearch, isLoading }) {
  const [query, setQuery] = useState("");
  const [topK, setTopK] = useState(5);

  function handleSubmit(e) {
    e.preventDefault();
    const trimmed = query.trim();
    if (!trimmed || isLoading) return;
    onSearch(trimmed, topK);
  }

  function handleKeyDown(e) {
    if (e.key === "Enter") handleSubmit(e);
  }

  return (
    <form className="search-bar" onSubmit={handleSubmit} role="search" aria-label="Semantik Arama">
      <div className="search-bar__input-row">
        <input
          id="search-input"
          className="search-bar__input"
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Belgelerde aramak istediğiniz konuyu Türkçe yazın..."
          aria-label="Arama sorgusu"
          autoComplete="off"
          disabled={isLoading}
        />
        <button
          id="search-button"
          className={`search-bar__button ${isLoading ? "search-bar__button--loading" : ""}`}
          type="submit"
          disabled={!query.trim() || isLoading}
          aria-label="Ara"
        >
          {isLoading ? (
            <>
              <span className="spinner" aria-hidden="true" />
              Aranıyor...
            </>
          ) : (
            <>
              <svg className="search-bar__icon" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
              </svg>
              Ara
            </>
          )}
        </button>
      </div>

      <div className="search-bar__options">
        <label className="search-bar__topk-label" htmlFor="topk-slider">
          Sonuç sayısı:
          <span className="search-bar__topk-value">{topK}</span>
        </label>
        <input
          id="topk-slider"
          className="search-bar__slider"
          type="range"
          min={1}
          max={20}
          value={topK}
          onChange={(e) => setTopK(Number(e.target.value))}
          aria-label={`Sonuç sayısı: ${topK}`}
          disabled={isLoading}
        />
      </div>
    </form>
  );
}

export default SearchBar;
